<template>
  <div class="file-viewer-error" role="status">
    <i class="fas fa-triangle-exclamation file-viewer-error__icon" aria-hidden="true" />
    <span>
      {{ t("modules.filemanagement.components.FMFileViewer.FMFileViewerPDF.unavailable") }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

const { t } = useTranslation();
</script>

<style lang="scss" scoped>
.file-viewer-error {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1rem;
  color: var(--p-text-muted-color);
  text-align: center;
}

.file-viewer-error__icon {
  color: var(--p-orange-500);
  font-size: 2rem;
}
</style>
